import React, { useContext } from "react";
import { StyleContext } from "./context/styleContext";
import { RouterProvider } from "react-router-dom";
import { router } from "./routing/router";
import { AIMSContextProvider } from "./context/AIMSContext";
import { ToastProvider } from "./context/toastContext";

export default function AppMainArea() {
  const { sideNavOpen } = useContext(StyleContext);

  // const style = auth.role
  //   ? sideNavOpen
  //     ? "main-area-side-nav-opened"
  //     : "main-area-side-nav-closed"
  //   : "";
  return (
    <div className={`container`}>
      <ToastProvider>
        <AIMSContextProvider>
          <RouterProvider router={router} />
        </AIMSContextProvider>
      </ToastProvider>
    </div>
  );
}
